import React, { useState, useEffect } from "react";
import { ChevronDown, Phone, Menu, X } from "lucide-react";
import Logo from "./Logo";
import { navItems } from "../mock";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-4 md:px-8 pt-4">
      <nav
        className={`max-w-[1440px] mx-auto bg-white rounded-full px-4 md:px-6 py-2.5 flex items-center justify-between gap-4 transition-shadow ${
          scrolled ? "shadow-xl" : "shadow-md"
        }`}
      >
        <a href="#" className="flex items-center pl-2">
          {/* <Logo /> */}
          <img src="/EEBS_logo_dark.png" alt="eebssolutions" className="w-[130px] h-auto -ml-2" />
        </a>

        {/* Desktop nav */}
        <ul className="hidden lg:flex items-center gap-1 text-[15px] font-medium text-[#0E0E10]">
          {navItems.map((item, i) => (
            <li
              key={item.label}
              className="relative"
              onMouseEnter={() => setOpen(i)}
              onMouseLeave={() => setOpen(false)}
            >
              <a
                href={item.href}
                className="flex items-center gap-1 px-4 py-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                {item.label}
                {item.children && (
                  <ChevronDown
                    className={`w-4 h-4 transition-transform ${
                      open === i ? "rotate-180" : ""
                    }`}
                  />
                )}
              </a>
              {item.children && open === i && (
                <div className="absolute top-full left-0 pt-2 min-w-[200px]">
                  <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden py-2">
                    {item.children.map((c) => (
                      <a
                        key={c.label}
                        href={c.href}
                        className="block px-5 py-2.5 text-sm hover:bg-[#2D6A4F]/10 transition-colors"
                      >
                        {c.label}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:01245493832"
            className="flex items-center gap-2 text-[15px] font-semibold text-[#0E0E10] hover:text-[#6B7C61] transition-colors"
          >
            <Phone className="w-4 h-4" />
            01245 493832
          </a>
          <a
            href="#contact"
            className="bg-[#2D6A4F] hover:bg-[#3D8B6A] text-white font-semibold px-5 py-2.5 rounded-full transition-colors"
          >
            Get a Quote
          </a>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setMobile(!mobile)}
          aria-label="Menu"
        >
          {mobile ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {/* Mobile menu */}
      {mobile && (
        <div className="lg:hidden max-w-[1440px] mx-auto mt-2 bg-white rounded-3xl shadow-xl p-4">
          <ul className="flex flex-col">
            {navItems.map((item) => (
              <li key={item.label} className="border-b border-gray-100 last:border-0">
                <a
                  href={item.href}
                  className="block py-3 px-2 font-medium"
                  onClick={() => setMobile(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            className="mt-4 block text-center bg-[#2D6A4F] text-white font-semibold py-3 rounded-full"
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
